import { useCallback } from 'react';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { useHttpClient } from '../../client/HttpClientContext';
import { marketplaceAppStatusCache } from '../../cache';
export const useMarketplaceAppStatus = ({
  appId,
  skip
}) => {
  const httpClient = useHttpClient();
  const getLinkedInIntegrationStatus = useCallback(() => {
    return marketplaceAppStatusCache.get(appId, httpClient);
  }, [appId, httpClient]);
  return useAsyncFunction(getLinkedInIntegrationStatus, {
    skip
  });
};